import request from '@/utils/request'

/**
 * 获取秒杀商品列表
 * @param {Object} params 查询参数 {shopId, prodNameLike, page, row}
 * @returns {Promise} 包含秒杀商品列表的Promise
 */
export function getSeckillList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.listAdminSeckill',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 创建秒杀商品
 * @param {Object} data 秒杀商品数据
 * @returns {Promise} 操作结果的Promise
 */
export function createSeckillProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.saveSeckill',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新秒杀商品
 * @param {Object} data 秒杀商品数据
 * @returns {Promise} 操作结果的Promise
 */
export function updateSeckillProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.updateSeckill',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除秒杀商品
 * @param {String} seckillId 秒杀商品ID
 * @returns {Promise} 操作结果的Promise
 */
export function deleteSeckillProduct(seckillId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.deleteSeckill',
      method: 'post',
      data: { seckillId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取秒杀时间段配置
 * @returns {Promise} 包含时间段配置的Promise
 */
export function getSeckillTimeConfig() {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.getSeckillTimeConfig',
      method: 'get'
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取秒杀活动统计
 * @param {String} shopId 店铺ID
 * @returns {Promise} 包含统计数据的Promise
 */
export function getSeckillStats(shopId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.getSeckillStats',
      method: 'get',
      params: { shopId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}